import { LottieAnimationData } from '@/libs/contentful/props';

export function isValidAnimation(lottie?: LottieAnimationData | null) {
  if (!lottie) return false;
  return !!Object.keys(lottie).length;
}
